import * as React from "react";
import { RunParameter } from "../../../api";
import { TranslationContext } from "../Contexts/TranslationContext";
import { ClientResources, CaseRunCreateModelBase } from "@app/api2/api";
import { HandlerRegistry } from "./RunTypes/HandlerRegistry";

interface IReviewProps {
    model: CaseRunCreateModelBase;
    onComplete: (values: any) => void;
    router: any;
}

class ReviewState {

}

export class Review extends React.Component<IReviewProps, ReviewState> {
    
    constructor(props, context) {
        super(props, context);

        this.state = {

        };
        

    }
    

    isRowVisible = (p: RunParameter) => {
        if (!p.userVisible) {
            return false;
        }
        if (!p.showIfChecked) {
            return true;
        }

        var fields = p.showIfChecked.split(',');

        var falseFields = fields.filter(f => f.startsWith("!")).map(m => m.slice(1));
        var trueFields = fields.filter(f => !f.startsWith("!"));

        var values = this.props.model.parameters.reduce((dict, curr) => {
            dict[curr.parameter] = curr.value;
            return dict;
        }, {});

        return falseFields.reduce((show, field) => show && !(values[field] === "1"), true) && trueFields.reduce((show, field) => show && (values[field] === "1"), true);
    };

    render() {
        const handler = HandlerRegistry.getRunTypeHandler(this.props.model.runType);
        return (
            handler.renderReview(this.props.model, this.props.onComplete, this.props.router)
        );
    }
}